/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 */
//入口
// import { order } from '../../api';
// import importAll from '@/tools/importAll';
// const children  = importAll(require.context('./'))

import { orderManagement } from '@/api/ajax';
import fields from '@/page/settlementCenter/projectSettled/common/fields.js';
import search from '@/page/settlementCenter/projectSettled/common/search.js';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import _fields from './fields.js';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';

const example = new TableRenderClass({
  fields: { ...fields, ..._fields },
  search
});

export const listOrderDetail = [
  {
    name: '订单详情',
    childMenu: [
      example.createPart({
        name: '订单详情',
        list: orderManagement.orderDetails,
        requestNow: true,
        fields: [
          'index',
          'orderNo',
          'createDt',
          'orderDetailPayProgress',
          'zhongduanjinejiesuanheji',
          'xiangmuzhifujine',
          PAY_BANK_TYPE_KEY,
          PAY_TYPE_KEY
        ]
      })
    ]
  }
];
